@if (!singleTooth) {
  <div #leftTexts class="absolute z-10 ml-[-80px] h-full w-[110px]"></div>
}
<div #chart class="relative h-full w-full grid-cols-2">
  <lib-perio-compare-overlay
    [compareSelected]="compareSelected()"
    [selectedQuadrant]="selectedQuadrant()"
    [currentTopRightTeeth]="currentTopRightTeeth()"
    [currentTopLeftTeeth]="currentTopLeftTeeth()"
    [currentBottomLeftTeeth]="currentBottomLeftTeeth()"
    [currentBottomRightTeeth]="currentBottomRightTeeth()"
    [currentSelectedQuadrantTeeth]="currentSelectedQuadrantTeeth()"
    [previousTopRightTeeth]="previousTopRightTeeth()"
    [previousTopLeftTeeth]="previousTopLeftTeeth()"
    [previousBottomLeftTeeth]="previousBottomLeftTeeth()"
    [previousBottomRightTeeth]="previousBottomRightTeeth()"
    [previousSelectedQuadrantTeeth]="previousSelectedQuadrantTeeth()"
  ></lib-perio-compare-overlay>
</div>
